import React, { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import API from '../../../../utils/API';
import { FormattedMessage, injectIntl } from 'react-intl';
import totalReceivers from "../../../../assets/icons/signage-plus/total-receivers.svg";
import totalPlaylists from "../../../../assets/icons/signage-plus/total-playlists.svg";
import storageUsed from "../../../../assets/icons/signage-plus/storage-used.svg";
import StatCard from '../../../../components/SignagePlus/StatCard';
import SignageStatusTable from './SignageStatusTable';
import SignageHistoryTable from './SignageHistoryTable';
import SignageScheduledTable from './SignageScheduledTable';
import constants from '../../../../utils/constants';
import Banner from '../../../../components/SignagePlus/Banner';
import NotificationModal from '../../../../components/MessageManager/NotificationModal';
import dustbin from '../../../../assets/icons/message-manager/dustbin.svg';

function SignageDashboardOwner(props) {
  const [error, setError] = useState('');
  const [summaryData, setSummaryData] = useState([]);
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission) => permission.id);

  if (!permissionIds.includes(constants.permissionIds.signagePlusOwner)) {
    navigate('/forbidden');
  }
  const [notificationProps, setNotificationProps] = useState({
    icon: dustbin,
    message: 'STOP_SIGNAGE',
    description: 'STOP_SIGNAGE_DESCRIPTION',
    showSecondaryButton: true,
    primaryButtonText: 'STOP',
  });
  const modalRef = useRef(null);

  useEffect(() => {
    modalRef.current = new window.bootstrap.Modal(document.getElementById('notificationModal'));
  }, []);

  const loadSummaryData = async (map, resetSelection = true) => {
    let summary = [
      {
        icon: totalReceivers,
        title: "TOTAL_RECEIVERS",
        number: [0, 0, 0],
        unit: ["ACTIVE", "IDLE", "OFFLINE"],
        colors: ["#36B199", "#2196F3", "#EC1C24"],
      },
      {
        icon: totalPlaylists,
        title: "TOTAL_PLAYLISTS",
        number: 0,
        unit: "PLAYLISTS",
        colors: ['#000000']
      },
      {
        icon: storageUsed,
        title: "STORAGE_USED",
        number: [0.00, 0],
        unit: ["GB", "GB"],
        colors: ['#000000', '#000000']
      }
    ];

    try {
      const res = await API.getSignageDashboardSummary('owner');
      summary = [
        {
          icon: totalReceivers,
          title: "TOTAL_RECEIVERS",
          number: [res.data?.totalActive ?? 0, res.data?.totalIdel ?? 0, res.data?.totalOffline ?? 0],
          unit: ["ACTIVE", "IDLE", /*"INACTIVE",*/ "OFFLINE"],
          colors: ["#36B199", "#2196F3", /*"#000000",*/ "#EC1C24"],
        },
        {
          icon: totalPlaylists,
          title: "TOTAL_PLAYLISTS",
          number: res.data?.totalPlaylists ?? 0,
          unit: "PLAYLISTS",
          colors: ['#000000']
        },
        {
          icon: storageUsed,
          title: "STORAGE_USED",
          number: [res.data?.totalConsumption?.toFixed(2) ?? 0.00, res.data?.totalCapacity ?? 0],
          unit: ["GB", "GB"],
          colors: ['#000000', '#000000']
        }
      ];
    } catch (err) {
      // If it's error 502, skip error handling
      if ((err.response && err.response.status === 502) || (err.response?.data?.error)) {
        return;
      }
      setError(err.message);
    } finally {
      setSummaryData(summary);
    }
  };
  const [updateFlag, setUpdateFlag] = useState(false);

  const statusTableRef = useRef();
  const historyTableRef = useRef();
  const scheduledTableRef = useRef();

  const loadStatusTable = (loadFunction) => {
    statusTableRef.current = loadFunction;
  };

  const loadHistoryTable = (loadFunction) => {
    historyTableRef.current = loadFunction;
  };

  const loadScheduledTable = (loadFunction) => {
    scheduledTableRef.current = loadFunction;
  };

  useEffect(() => {
    let interval;
    let isMounted = true;
    const loadData = async () => {
      if (!isMounted) return;
      loadSummaryData();
      if (statusTableRef.current) await statusTableRef.current();
      if (historyTableRef.current) await historyTableRef.current();
      if (scheduledTableRef.current) await scheduledTableRef.current();
      interval = setTimeout(loadData, 5000);
    };
    loadData();
    return () => {
      isMounted = false;
      clearTimeout(interval);
    };
  }, []);

  return (
    <>
      <NotificationModal {...notificationProps} />
      <Banner />
      <div className="row" style={{ marginLeft: '-12.5px', marginRight: '-12.5px' }}>
        {summaryData.map((item, idx) => (
          <div
            className="col-12 col-md-4"
            key={idx}
            style={{ paddingLeft: 12.5, paddingRight: 12.5, marginBottom: 25 }}
          >
            <StatCard {...item} />

          </div>
        ))}
      </div>
      <SignageStatusTable
        setNotificationProps={setNotificationProps}
        updateFlag={updateFlag}
        setUpdateFlag={setUpdateFlag}
        onLoadStatusTable={loadStatusTable}
        modalRef={modalRef}
      />
      <SignageScheduledTable
        setNotificationProps={setNotificationProps}
        updateFlag={updateFlag}
        setUpdateFlag={setUpdateFlag}
        onLoadScheduledTable={loadScheduledTable}
        modalRef={modalRef}
      />
      <SignageHistoryTable
        updateFlag={updateFlag}
        onLoadHistoryTable={loadHistoryTable}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(injectIntl(SignageDashboardOwner))
